<template>
  <section>
    <div>
      <h2 class="">{{ trainer.title }}</h2>
      <back v-show="status === 'init'"></back>
    </div>  

    <!-- настройки -->

    <div class="wh-block" v-show="status === 'init'">
      <Settings :trainer="trainer" @start="start" />
		</div>

    <!-- игра -->

		<Game 
      v-if="status === 'start'" 
      :params="params" 
      :cards="cards"
      @stop="status = 'init'" 
      @show-result="showResult"
    />

    <!-- результат -->

    <div class="game" v-if="status === 'result'">
      <Result        
        :result="result"
        @again="start" 
        @stop="status = 'init'" 
      />
    </div>
  </section>
</template>

<script>
import Settings from './components/Settings.vue'
import Game from './components/Game.vue'
import Result from './components/Result.vue'
import { mapGetters } from 'vuex'

export default {  
  props: ['trainer'],
  components: { Settings, Game, Result },
  data() {
    return {
      params: {},
      status: 'init',
      result: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    cards() {
      // let images = this.trainer.images.filter(item => item.file_name.includes('Жора'))
      // let cardBack = this.trainer.images.find(item => item.file_name.includes('Рубашка'))

      let images = this.trainer.images.filter(item => item.file_name.includes('zhora'))
      let cardBack = this.trainer.images.find(item => item.file_name.includes('rubashka'))
      let cards = []

      images.forEach(img => {
        cards.push({
          name: img.file_name.split('.')[0],
          url: img.path,
          isShow: this.params.startTime > 0 ? true : false,
          isComplete: false,
          backUrl: cardBack.path
        })
      })

      return cards
    }
  },
  methods: {
    start(params) {
      this.params = params
      this.status = 'start'
    },
    showResult(data) {      
      this.result = data
      this.result.gameParams = this.params
      this.result.user_id = this.user.id
      this.result.trainer = this.trainer.id
      this.status = 'result'   
    }    
  },
  mounted() { 
    if (this.$route.params.isHomework) {
      this.start(this.$route.params.params)
    }
  }
}
</script>